import { render, staticRenderFns } from "./ItensConsumidosList.vue?vue&type=template&id=31fec523"
import script from "./ItensConsumidosList.vue?vue&type=script&lang=js"
export * from "./ItensConsumidosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports